<swiper-container init="false" #container [class.pagination-top]="paginationTop">
  <ng-content></ng-content>
</swiper-container>
